module.exports = __webpack_public_path__ + "static/media/logo.e74b5779.svg";